export default __webpack_public_path__ + "static/media/Arrow-DarkGray.79992d8e.svg";